import { useRef, useState } from "react";

import { useSettings } from "../App";

export default function Uploader({
  onFiles,
  disabled,
}: {
  onFiles: (files: File[]) => void;
  disabled?: boolean;
}) {
  const [over, setOver] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const { settings } = useSettings();

  const extensions = settings?.supported_extensions ?? [
    ".pdf", ".docx", ".md", ".txt", ".png", ".jpg",
  ];

  const handle = (list: FileList | null) => {
    if (!list || disabled) return;
    const files = Array.from(list);
    if (files.length) onFiles(files);
  };

  return (
    <>
      <div
        className={`dropzone${over ? " is-over" : ""}`}
        onDragOver={(e) => {
          e.preventDefault();
          if (!disabled) setOver(true);
        }}
        onDragLeave={() => setOver(false)}
        onDrop={(e) => {
          e.preventDefault();
          setOver(false);
          handle(e.dataTransfer.files);
        }}
        onClick={() => !disabled && inputRef.current?.click()}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") inputRef.current?.click();
        }}
        aria-disabled={disabled}
      >
        <strong>Drop your study materials here</strong>
        <div className="small">or click to choose files</div>
        <div className="small faint" style={{ marginTop: 10 }}>
          PDF · DOCX · Markdown · TXT · images
          {settings && ` — up to ${settings.max_upload_mb} MB each`}
        </div>
      </div>
      <input
        ref={inputRef}
        type="file"
        multiple
        accept={extensions.join(",")}
        style={{ display: "none" }}
        onChange={(e) => {
          handle(e.target.files);
          e.target.value = "";
        }}
      />
    </>
  );
}
